export const BASE_TABLE_LAYOUT_SX = {
  padding: 0,
  paddingTop: 2,
  overflow: 'hidden',
};
export const NUMBER_FORMAT_OPTIONS = { minimumFractionDigits: 2 };
export const DEFAULT_APPROVED_AMOUNT_COLUMN_WIDTH = 200;
export const VARIANCE_CELL_SX = {
  backgroundColor: 'error.lighter',
};

/** After tenant events submit, stats/RA may populate asynchronously; poll briefly. */
export const HUD_ASYNC_DATA_REFRESH_POLL_MS = 3000;
export const HUD_ASYNC_DATA_REFRESH_DURATION_MS = 120000;
